/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-useless-computed-key */
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Col, Row } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import TagsList3 from "components/TagList3";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import CheckBox from "components/Form/CheckBox";
import InputField from "components/Form/InputField";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Title, ButtonContent } from "./styles";
import { LostCancelButton } from 'components/index';
import StepNavigation from "components/StepNavigation/index";
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";
import { useBindMessage, useWordingHtmlModal, useHeaderNbi, useListContactsByType, useGetDocuments, useGetSchedulleAssumptions, useBind } from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService';
import { useGetQuestionnaireAnswer } from '@fitinsur/services/QuestionnaireAnswerService';
import { EndorsementTagList, FileModal } from '@fitinsur/components'


export default function SendOrderToBind(props) {

    const [file, setFile] = useState();
    const [summary, setSummary] = useState({});
    const [wordingFile, setWordingFile] = useState({});
    const [scheduleAssumptionsFile, setScheduleAssumptionsFile] = useState({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [client, setClient] = useState([]);
    const [endorsmentType, setEndorsmentType] = useState("");
    const [isBound, setIsBound] = useState(false);
    const [endorsementDocuments, setEndorsementDocuments] = useState([]);
    const [includeSchedulleQst, setIncludeSchedulleQst] = useState(null);
    const [operation, setOperation] = useState(null);

    const loading = useContext(GlobalLoaderContext);
    const authContext = useContext(GlobalAuthContext);
    const formik = useRef(null);
    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();

    const {
        data: useBindMessageData,
        loading: useBindMessageLoading,
        error: useBindMessageError,
        status: useBindMessageStatus,
        request: useBindMessageRequest,
    } = useBindMessage(props.match.params.idOperation);

    const {
        data: useWordingHtmlModalData,
        loading: useWordingHtmlModalLoading,
        error: useWordingHtmlModalError,
        status: useWordingHtmlModalStatus,
        request: useWordingHtmlModalRequest,
    } = useWordingHtmlModal(props.match.params.idOperation);

    const {
        data: useHeaderNbiData,
        loading: useHeaderNbiLoading,
        error: useHeaderNbiError,
        status: useHeaderNbiStatus,
        request: useHeaderNbiRequest,
    } = useHeaderNbi();

    const {
        data: useListContactsByTypeData,
        loading: useListContactsByTypeLoading,
        error: useListContactsByTypeError,
        status: useListContactsByTypeStatus,
        request: useListContactsByTypeRequest,
    } = useListContactsByType('client', props.match.params.idOperation);

    const {
        data: useGetDocumentsData,
        loading: useGetDocumentsLoading,
        error: useGetDocumentsError,
        status: useGetDocumentsStatus,
        request: useGetDocumentsRequest,
    } = useGetDocuments(props.match.params.idOperation);

    const {
        data: useGetSchedulleAssumptionsData,
        loading: useGetSchedulleAssumptionsLoading,
        error: useGetSchedulleAssumptionsError,
        status: useGetSchedulleAssumptionsStatus,
        request: useGetSchedulleAssumptionsRequest,
    } = useGetSchedulleAssumptions(props.match.params.idOperation);

    const {
        data: useOperationInfoData,
        loading: useOperationInfoLoading,
        error: useOperationInfoError,
        status: useOperationInfoStatus,
        request: useOperationInfoRequest,
    } = useOperationInfo(props.match.params.idOperation);

    const {
        data: useBindData,
        loading: useBindLoading,
        error: useBindError,
        status: useBindStatus,
        request: useBindRequest,
    } = useBind(props.match.params.idOperation, "send");

    const {
        data: useGetQuestionnairesAnswersData,
        loading: useGetQuestionnairesAnswersLoading,
        error: useGetQuestionnairesAnswersError,
        status: useGetQuestionnairesAnswersStatus,
        request: useGetQuestionnairesAnswersRequest,
    } = useGetQuestionnaireAnswer(props.match.params.idOperation);

    useEffect(() => {
        if (useBindMessageLoading || useWordingHtmlModalLoading || useHeaderNbiLoading || useListContactsByTypeLoading || useGetDocumentsLoading ||
            useGetSchedulleAssumptionsLoading || useOperationInfoLoading || useBindLoading || useGetQuestionnairesAnswersLoading) {
            loading.start();
        } else {
            loading.stop();
        }
    }, [useBindMessageLoading, useWordingHtmlModalLoading, useHeaderNbiLoading, useListContactsByTypeLoading, useGetDocumentsLoading,
        useGetSchedulleAssumptionsLoading, useOperationInfoLoading, useBindLoading, useGetQuestionnairesAnswersLoading]);


    const isClient = authContext.enumProfile == 1 ? true : false;

    const validation = () => {
        if (selectedItems.length >= 1) {
            return true;
        }
        else {
            return false;
        }
    }

    function handleSummary() {
        useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
            setSummary({
                typeOfCover: data.ret_value.typeOfCover,
                client: data.ret_value.client,
                obligorCoding: data.ret_value.obligorCoding,
                responseBy: data.ret_value.responseBy,
                internalContact: data.ret_value.internalContact,
                broker: data.ret_value.broker,
                dealCode: data.ret_value.deal,
                nmFacility: data.ret_value.nmFacility,
                nmObligor: data.ret_value.nmObligor,
                idOperation: props.match.params.idOperation,
                projectName: data.ret_value.projectName,
            });
            setEndorsmentType(data.ret_value.endorsmentType);
            handleGetModal(data.ret_value.endorsmentType);
        })
            .catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitPostSummary - Error:', error);
            });
    };

    function handleSendApproval() {
        let valid = validation(); if (valid != true) { mc.error('Please fill in all required fields.'); return }

        let body = {
            policyPackMessage: formik.current.values.orderToBindMessage,
            cc: null,
            client: [],
            action: 'send'
        };

        client.forEach(x => {
            body.client.push({
                idPersonClient: x.idPersonClient,
                contacts: []
            })
        })

        selectedItems.forEach(x => {
            let i = body.client.findIndex(e => e.idPersonClient == x.idPersonClient);
            if (i != -1) {
                body.client[i].contacts.push({ idContact: x.idContact, email: x.email });
            }
        })


        useBindRequest({ ...body }).then(({ data }) => {
            if (data.ret_code !== 200) {
                mc.error(data.ret_msg_details);
                return;
            }
            if (endorsmentType && endorsmentType !== "declaration") {
                return history.push('/policies');
            } else {
                return history.push('/list');
            }
        })
            .catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitPostReject - Error:', error);
            });
    }

    function handleGetModal(endorsmentType) {
        useWordingHtmlModalRequest().then(({data: resp}) => {
            if (resp.ret_code === 200) {
                setFile(resp.ret_value.policePackReturnDocs
                  .filter(document => {
                      const isEndorsement = endorsmentType && endorsmentType !== 'declaration';

                      if (!isEndorsement) return true;

                      return isEndorsement && ![272, 399, 401, 450, 453, 397, 493].includes(document.idDomain);
                  })
                  .map(document => ({
                      idDocument: document.idDocument,
                      idDomainDescription: document.idDomainDescription,
                      idReport: document.idReport,
                      idOperation: document.idOperation,
                      reportToken: document.reportToken,
                      url: document.url,
                      fileName: document.documentMetadata.fileName
                  })))
            } else {
                mc.error(resp.ret_msg_details);
            }
        }).catch((error) => {
            mc.error(`There was an error while fetching your data: ${handleGetModal.name}\n` + error);
            console.error('fitPostReject - Error:', error);
        });
    };

    async function handleOperationInfo() {
        useOperationInfoRequest().then(({ data: response }) => {
            setIsBound(response?.isBound);
            setOperation(response);
        })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
            });
    }

    const handleEnable = () => {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.wordingAttachments(props.match.params.idOperation).then(x => x.json()).then(res => {
            if (res.ret_code !== 200) {
                mc.error(res.ret_msg_details);
                return;
            }
        });
    }

    async function handleGetFiles() {
        useGetDocumentsRequest().then(({ data: response }) => {
            if (response.ret_code !== 200) {
                mc.error(response.ret_msg_details);
                return;
            }

            if (response.ret_value.length > 0) {
                const file = response.ret_value[0];
                setWordingFile({
                    dsTypeDocument: file.dsTypeDocument || "Wording",
                    nameDocument: file.nameDocument,
                    idTypeDocument: file.idTypeDocument,
                    nameFile: file.nameFile,
                    size: file.size,
                    type: file.type,
                    urlLink: file.urlLink,
                    idDocument: file.idDocument
                });
            }
            return response.ret_value;
        }).catch((error) => {
            mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
            console.error('fitPostFiles - Error:', error);
        });

        if (includeSchedulleQst?.idAnswerOption && includeSchedulleQst?.idAnswerOption === 7530) {
            useGetSchedulleAssumptionsRequest().then(({ data: response }) => {
                if (response.ret_code !== 200) {
                    // mc.error(response.ret_msg_details);
                    return;
                }

                if (response.ret_value.length > 0) {
                    const file = response.ret_value[0];
                    setScheduleAssumptionsFile({
                        dsTypeDocument: "Schedule",
                        nameDocument: file.nameDocument,
                        idTypeDocument: file.idTypeDocument,
                        nameFile: file.nameFile,
                        size: file.size,
                        type: file.type,
                        urlLink: file.urlLink,
                        idDocument: file.idDocument
                    });
                }
                return;
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${fitinsur.requestAttachAssumptions.name}\n` + error);
                console.error('fitPostReject - Error:', error);
            });
        }

    }

    function handleSelect(e) {
        const contact = { idContact: e.idContact, email: e.email };

        const alreadySelected = selectedItems.findIndex((item) => item.email === contact.email);
        if (alreadySelected >= 0) {
            const filteredItems = selectedItems.filter((item) => item.email !== contact.email);
            setSelectedItems(filteredItems);
        } else {
            let list = [...selectedItems];
            list.push(contact);
            setSelectedItems([...list]);
        };
    };

    function listContacts(idContactDepartment) {
        useListContactsByTypeRequest(null, { idContactDepartment: idContactDepartment }).then(({ data }) => {
            if (data.ret_code != 200) {
                mc.error(data.ret_msg_details);
                history.goBack();
                return;
            }
            setClient(data.ret_value);
        })
            .catch((error) => {
                mc.error("There was an error processing your request. Please try again later");
                console.error('fitPostListContact - Error:', error);
            });
    };

    const listItems = client.length ? client.map((client) => (
        <>
            <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
                <Col style={{ flexDirection: "row", display: "flex" }}>
                    <label>
                        <CheckBox
                            onChange={() => { handleSelect(client) }}
                            checked={selectedItems.find((item) => item.email === client.email) ? true : false}
                            disabled={client.existContact ? true : false}
                        />
                    </label>
                    <Label textColor={client?.existContact ? Colors.GRAY[3] : null}>
                        {client.legalEntity}
                    </Label>
                </Col>
                <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                    <Label textColor={client?.existContact ? Colors.GRAY[3] : null}>{client.nameContact}</Label>
                </Col>
                <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                    <Label textColor={client?.existContact ? Colors.GRAY[3] : null}>{client?.personContactDepartment}</Label>
                </Col>
                <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                    <Label textColor={client?.existContact ? Colors.GRAY[3] : null}>{client.email}</Label>
                </Col>
            </Row>
        </>
    )) : (
        <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
            <Title>
                No results found.
            </Title>
        </Row>);

    function requestBindMessage() {
        useBindMessageRequest().then(({ data: resp }) => {
            if (resp.ret_code != 200) {
                mc.error(resp.ret_msg_details);
                history.goBack();
                return;
            }

            if (formik.current) {
                formik.current?.setFieldValue('orderToBindMessage', resp.ret_value.orderToBindMessage);
            }
        }).catch((error) => {
            mc.error("Erro executando consulta\n" + error);
            console.error('fitPostReject - Error:', error);
        });
    };

    async function handleSchedulleAssumptions(includeSchedulle) {
        if (includeSchedulle?.idAnswerOption && includeSchedulle?.idAnswerOption == 7530) {
            useGetSchedulleAssumptionsRequest().then(({ data: response }) => {
                if (response.ret_code !== 200) {
                    return;
                }
                if (response.ret_value.length > 0) {
                    const file = response.ret_value[0];
                    setScheduleAssumptionsFile({
                        dsTypeDocument: "Schedule Assumptions",
                        nameDocument: file.nameDocument,
                        idTypeDocument: file.idTypeDocument,
                        nameFile: file.nameFile,
                        size: file.size,
                        type: file.type,
                        urlLink: file.urlLink,
                        idDocument: file.idDocument
                    });
                }
                return;
            }).catch((error) => {
                // mc.error(`There was an error while fetching your data: ${fitinsur.requestAttachAssumptions.name}\n` + error);
                console.error('fitPostReject - Error:', error);
            });
        }
    }

    const handleEndorsementDocuments = (data) => {
        const questionnaire = [
            ...data.persons,
            ...data.operations,
            ...data.payments,
            ...data.risks,
            ...data.mrc
        ]

        const endorsementDoumentsQst = questionnaire.find((qst) => qst.idQuestion === 1867);
        const includeSchedulle = questionnaire.find((qst) => qst.idQuestion === 1870)

        handleSchedulleAssumptions(includeSchedulle)

        if (endorsementDoumentsQst?.answer) {
            const documents = JSON.parse(endorsementDoumentsQst.answer) || []
            setEndorsementDocuments(documents);
        }
    }

    useEffect(() => {
        if (useGetQuestionnairesAnswersStatus === 200) {
            handleEndorsementDocuments(useGetQuestionnairesAnswersData?.value)
        }
    }, [useGetQuestionnairesAnswersStatus]);

    useEffect(() => {
        if (isClient === true) {
            history.push('/list');
            return;
        }
        requestBindMessage();
        handleSummary();
        handleEnable();
        listContacts();
        handleGetFiles();
        handleOperationInfo();
    }, [])

    useEffect(() => {
        if (endorsmentType !== '') {
            useGetQuestionnairesAnswersRequest();
        }
    }, [endorsmentType])

    const endorsmentTypeEnum = {
        ['not-pre-agreed']: {
            title: 'Anniversary: Premium Not Pre-Agreed / Order to Bind'
        },
        ['cancellation']: {
            title: 'Endorsement - Cancellation / Order to Bind'
        }
    }

    function handleMktCompostion() {
        history.push(`/broking/market-composition/${props.match.params.idOperation}`)
    };

    return (
        <Layout
            idOperation={props.match?.params?.idOperation}
            title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
            subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
        >
            <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
            <BrokingSummary data={summary} />

            <ContentCard
                title={endorsmentTypeEnum[endorsmentType] ? endorsmentTypeEnum[endorsmentType].title : 'Order To Bind'}
                icon
                info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}
                filterContact
                handleFilterContact={(idContactDepartment) => listContacts(idContactDepartment)}
            >
                <Formik
                    innerRef={formik}
                    initialValues={{}}
                    onSubmit={handleSendApproval}
                >
                    {formikProps => (
                        <Form>
                            <>
                                <Title>TO</Title>
                                {listItems}
                            </>
                            <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                                <Title>
                                    CC
                                </Title>
                            </Row>
                            <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
                                <Col sm={6}>
                                    <Field
                                        name={'cc'}
                                        value={formikProps.values.policyPackMessage}
                                        onChange={(e) => formikProps?.setFieldValue('cc', e)}
                                        component={InputField}
                                        disabled
                                    />
                                </Col>
                            </Row>
                            <Field
                                label={'Order to Bind Message - (External)'}
                                name={'orderToBindMessage'}
                                value={formikProps.values.OrderToBindMessage}
                                onChange={(e) => formikProps?.setFieldValue('orderToBindMessage', e)}
                                component={TextField}
                            />
                            <FileModal idOperation={props?.match?.params?.idOperation} documents={file} />

                            <HasPermission
                              permission={![26, 27].includes(operation?.idDomain) || endorsmentType === 'market-changes'}>
                            <EndorsementTagList
                                tags={endorsementDocuments}
                                showRemoveIcon={false}
                                attachments={wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile ? [wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile) : []}
                            />

                            {wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile && (!endorsmentType || endorsmentType === '') ?
                                <>
                                    <Label>Policy Pack Documents</Label>
                                    <TagsList3
                                        tags={[wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile)}
                                        disableType
                                        hideTrash={props.location?.state?.hideFooter ? true : false}
                                    />
                                </>
                                : ''}
                            </HasPermission>
                            
                            <ButtonContainer>
                                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                                <RenderButtons idOperation={props.match?.params?.idOperation}>
                                    <HasPermission permission={!isBound}>
                                        <ButtonContent>
                                            <div style={{ marginLeft: "10px", marginTop: "5px" }}>
                                                <LostCancelButton idOperation={props.match?.params?.idOperation} />
                                            </div>
                                            <HasPermission permission={props.permissions.MARKETING_COMPOSITION}>
                                                <Button
                                                    third
                                                    style={{ marginLeft: "10px", marginTop: "5px" }}
                                                    name="CDR"
                                                    id="mktComposition"
                                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMktCompostion() }}>
                                                    CDR
                                                </Button>
                                            </HasPermission>
                                            <HasPermission permission={props.permissions.ORDER_TO_BIND_GENERATE}>
                                                <Button
                                                    style={{ marginLeft: "10px", marginTop: "5px" }}
                                                    primary
                                                    type="submit"
                                                    id="btnSubmit"
                                                >
                                                    SEND
                                                </Button>
                                            </HasPermission>
                                        </ButtonContent>
                                    </HasPermission>
                                </RenderButtons>
                            </ButtonContainer>
                        </Form>
                    )}
                </Formik>
            </ContentCard>
            {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
        </Layout>
    );
}
